import { Platform } from "react-native";
import Cookies from "universal-cookie";
import { getStringData, storeStringData } from "./db/db";
import store from "../redux/store";
import { changeLanguage } from "../redux/main/mainAction";

const cookies = new Cookies();

export default async function getLanguage() {
  let language = null;
  if (Platform.OS === "web") {
    language = cookies.get("language");
  } else {
    language = await getStringData("language");
  }
  store.dispatch(changeLanguage(language));
  
  return language;
}

function setLanguage(language) {
  if (Platform.OS === "web") {
    cookies.set("language", language);
  } else {
    storeStringData("language", language);
  }
  store.dispatch(changeLanguage(language));
}

export { setLanguage };
